import React, { useEffect, useState } from "react";
import { postData } from "../../../services/api";
import { useTranslation } from "react-i18next";
import Accordian from "../../Common/Accordian";
import Searching from "../../Searching";
import NoDataFound from "../../NoDataFound";

const Faqs = () => {
  const { i18n } = useTranslation();
  const [openAccordionId, setOpenAccordionId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [faqs, setfaqs] = useState([]);

  const toggleAccordion = (id) => {
    setOpenAccordionId(openAccordionId === id ? null : id);
  };

  useEffect(() => {
    const loadList = async () => {
      setLoading(true);
      const result = await postData("/faq/list", {
        sortQuery: { "created_at": -1 },
        limit: 100,
        offset: 0,
      });
      if (result.data) {
        setfaqs(
          result.data.map((item, index) => {
            return {
              title: item?.question?.[i18n?.language],
              content: item?.answer?.[i18n?.language],
            };
          })
        );
        setLoading(false);
      }
    };
    loadList();
  }, [i18n?.language]);

  return (
    <section className="w-full my-12 md:my-28" id="faqs-section">
      <div className="w-full">
        <div className="space-y-8 px-5">
          <div className="font-normal  text-black font-IBM text-[48px] text-center w-full">
            <span className="italic">Frequently</span>
            <br />
            <span className="font-light text-black">Asked Questions</span>
          </div>
        </div>
      </div>
      <div className="mt-5 w-full flex justify-center items-center">
        <div className="w-[1100px]">
          {faqs && faqs.length > 0 ? (
            faqs?.map((item, index) => {
              let evenOdd = index % 2 === 0 ? "even" : "odd";
              return (
                <div className="mb-4">
                  <Accordian
                    key={index}
                    id={index}
                    title={item.title}
                    isOpen={openAccordionId === index}
                    toggleAccordion={toggleAccordion}
                    divClass={
                      evenOdd === "even"
                        ? "bg-[#FFF6F6]  !rounded-md "
                        : "bg-[#F0F2FF]  !rounded-md"
                    }
                    textClass={
                      "!text-black !font-Outfit !text-[16px] !text-center !font-normal -mt-2"
                    }
                    iconClass={"-mt-2"}
                    icon="fa-solid fa-circle-plus"
                  >
                    <div className="text-sm md:text-base font-Inter text-slate-700">
                      {item?.content}
                    </div>
                  </Accordian>
                </div>
              );
            })
          ) : loading ? (
            <Searching label={"Searching"} />
          ) : (
            <NoDataFound label={"No Data Found"} />
          )}
        </div>
      </div>
    </section>
  );
};

export default Faqs;
